function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "https://www.w3.org/2000/svg",
  viewBox: "0 0 1400 980"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff",
    fillOpacity: 0,
    strokeWidth: 0.98678905
  },
  fill: "none",
  d: "M27.58 51.801h1381.505v967.053H27.58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.2 1162H49.8l55.2-96.6zm-100-6h89.7l-44.8-78.5z",
  style: {
    fill: "#333",
    fillOpacity: 1,
    stroke: "#333",
    strokeWidth: 1,
    paintOrder: "fill"
  },
  transform: "matrix(9.38522 0 0 9.38522 -117.963 -9934.582)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.2 1162H49.8l55.2-96.6zm-100-6h89.7l-44.8-78.5z",
  style: {
    fill: "#333",
    fillOpacity: 1,
    stroke: "#333",
    strokeWidth: 4,
    paintOrder: "fill"
  },
  transform: "matrix(7.03892 0 0 6.70373 -317.195 -6827.664)"
}));

export default SvgLogo;